import {
  TabList as TablistUnstyled,
  Tab as TabUnstyled,
  Tabs as TabsUnstyled,
  TabsProps,
  TabPanel as TabPanelUnstyled,
} from 'react-tabs';
import styled from 'styled-components';
import { style } from '../../api';
import { large, mobile, noDesktop, tablet } from '../../style/constants';

export const TabWithTitle = styled(TabUnstyled)`
  margin-left: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  line-height: 100%;

  font-size: 14px;

  :hover {
    cursor: pointer;
  }
`;

export const TabListWithTitle = styled(TablistUnstyled)`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0px;
  padding: 0px;

  height: 100%;

  /* font-weight: 500; */

  text-transform: capitalize;

  @media ${mobile} {
    overflow-x: auto;
  }

  color: ${style.grey_main_new};
  .react-tabs__tab--selected {
    font-weight: bold;
    color: ${style.primary_pink_new};
  }
`;

export const TabList = styled(TablistUnstyled)`
  display: flex;
  list-style: none;
  margin-top: 0;
  padding: 0px;
  text-align: center;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  color: ${style.grey_main_new};
  margin-bottom: 26px;
  margin-top: 26px;
  text-transform: capitalize;

  overflow: hidden;
  overflow-x: auto;

  .react-tabs__tab--selected {
    font-weight: bold;
    color: ${style.black};
    cursor: pointer;
    background-color: whitesmoke;
    border-radius: 5px;
  }

  @media ${mobile} {
    width: 360px;
  }
`;
export const Tab = styled(TabUnstyled)`
  padding: 1rem 1rem;
  :hover,
  :active,
  :focus {
    cursor: pointer;
    background-color: whitesmoke;
    border-radius: 5px;
    color: black;
  }
  @media ${mobile} {
    min-width: fit-content;
    padding: 1rem 1rem;
  }
  @media ${tablet} {
    min-width: 12rem;
    padding: 1.5rem 0.5rem;
  }
  @media ${large} {
    min-width: 0;
    padding: 1rem 1rem;
  }
`;
export const Tabs = styled(TabsUnstyled)<{ border?: boolean } & TabsProps>`
  border-radius: 5px;
  border: ${(p) =>
    p.border ? `1px solid ${style.pageTitleDividerGrey}` : 'none'};

  @media ${noDesktop} {
    padding: 0px;
  }

  /* .react-tabs__tab-list { */
  /* } */
`;
export const TabPanel = styled(TabPanelUnstyled)``;
